// extracted by mini-css-extract-plugin
export default {"checkoutBtn":"ReviewConfirm_checkoutBtn__qnauF"};